export default [
  {
    path: '/tickets/inbox',
    name: 'Tickets_Inbox',
    component: () => import('@/views/tickets/inbox.vue'),
    meta: {
      pageTitle: 'نامه های ورودی',
      authRequired: true,
      permission: 'tickets.index',
    },
  },
  {
    path: '/tickets/sent',
    name: 'Tickets_Sent',
    component: () => import('@/views/tickets/sent.vue'),
    meta: {
      pageTitle: 'نامه های ارسالی',
      authRequired: true,
      permission: 'tickets.sent',
    },
  },
  {
    path: '/tickets/create',
    name: 'Tickets_Create',
    component: () => import('@/views/tickets/create.vue'),
    meta: {
      pageTitle: 'ایجاد نامه',
      authRequired: true,
      permission: 'tickets.store',
    },
  },
  {
    path: '/tickets/closed',
    name: 'Tickets_Closed',
    component: () => import('@/views/tickets/closed.vue'),
    meta: {
      pageTitle: 'نامه های بسته شده',
      authRequired: true,
      permission: 'tickets.closed',
    },
  },
  {
    path: '/tickets/archive',
    name: 'Tickets_Archive',
    component: () => import('@/views/tickets/archive.vue'),
    meta: {
      pageTitle: 'نامه های آرشیو',
      authRequired: true,
      permission: 'tickets.archive',
    },
  },
  {
    path: '/tickets/:id',
    name: 'Tickets_Detail',
    component: () => import('@/views/tickets/[id].vue'),
    meta: {
      authRequired: true,
      permission: 'tickets.show',
    },
  },
  {
    path: '/tickets/:id/edit',
    name: 'Tickets_Edit',
    component: () => import('@/views/tickets/edit.vue'),
    meta: {
      authRequired: true,
      permission: 'tickets.update',
    },
  },

]
